import { render, staticRenderFns } from "./LogoIcon.vue?vue&type=template&id=98ddd73a&"
import script from "./LogoIcon.vue?vue&type=script&lang=js&"
export * from "./LogoIcon.vue?vue&type=script&lang=js&"
import style0 from "./LogoIcon.vue?vue&type=style&index=0&id=98ddd73a&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports